import axios from 'axios';
import http from './http-common';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';
 
//SME Api 
const get = (sId) => {  
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank "+ storage.getToken(),
          "Access-Control-Allow-Origin": "*"
        //   Pragma: 'no-cache' //IE11
        }
    }
       
    let stateId;
    if(sId) {
        stateId=sId;
    }
    else {
        stateId = storage.getStateId();
    }

 //  return axios.get(`http://localhost:3000/NSoleProps.json`);  //todo comment it for release
   return http.get(`/api/v1/SME/${stateId}`,headerParams); 
};

const post = (detailType,params) => {
    let stateId = storage.getStateId();
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank " + storage.getToken()
        }
    }
      
    if(detailType){
        return http.post(`/api/v1/SME/saveWithFields/${detailType}/${stateId}`,params,headerParams);
    }
    else {
        return http.post(`/api/v1/SME/submitWithFields/${stateId}`,params,headerParams);
    }
};

const verificationForm = (params) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank "+ storage.getToken()
        }
    }
      
    return http.post(`/api/v1/SME/VerificationForm`,params,headerParams);
}



//Address Api 
const getAddressApiUrl = () => {
    let addressApiUrl = '';
    switch (config.SERVER_STATUS) {
        case "DEV": addressApiUrl = config.AddressApi.DEV
        break;
        case "SIT": addressApiUrl = config.AddressApi.SIT 
        break;
        case "UAT": addressApiUrl = config.AddressApi.UAT 
        break;
        case "PROD": addressApiUrl = config.AddressApi.PROD 
        break;
        case "SIM": addressApiUrl = config.AddressApi.SIM 
        break;
        default:
        break;
    }
    return addressApiUrl;
};

const getSecurityApiUrl = () => {
    let apiUrl = '';
    switch (config.SERVER_STATUS) {
        case "DEV": apiUrl = config.SmeApi.DEV
        break;
        case "SIT": apiUrl = config.SmeApi.SIT 
        break;
        case "UAT": apiUrl = config.SmeApi.UAT 
        break;
        case "PROD": apiUrl = config.SmeApi.PROD 
        break;
        case "SIM": apiUrl = config.SmeApi.SIM 
        break;
        default:
        break;
    }
    return apiUrl;
}

const getAddress = data => {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': storage.getToken()
    }
    // return axios.post(getAddressApiUrl(), data, headers);
    const url = getAddressApiUrl();
    return axios.get(url+'/'+data);
}

const security = () => {
 
    // let params = { appId : "myinfopackageIW7cL4iFE5kf"}; // existing
    let params = { appID : "myinfopackageIW7cL4iFE5kf89ksaxdascsatwaaswdweyd"} //after server migration
    const headers = {
        'Content-Type': 'application/json'
    }
    let url = getSecurityApiUrl()+'/api/Security'
    return axios.post(url, params, headers);
}
 

const getMainConfig = (url) => {
    return axios.get(url);
}

const getBranches = (url) => {

   //return axios.get('http://localhost:3000/branch.json');
   return axios.get(url+'/branch.json'); 
}
 
export default {
    get,
    post,
    getAddress,
    getMainConfig,
    security,
    verificationForm,
    getBranches
};